import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertObligationInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export type InsertObligationInternalAuditResultInput = {
  InternalAuditReportId: string;
  ObligationIds: string[];
  Rating?: number | null;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

const mapTrpcResponseToGraphQL = (trpcData: {
  Ids: string[];
}): InsertObligationInternalAuditResultMutation => ({
  insertChildObligationInternalAuditResult: {
    __typename: 'InsertChildObligationAssessmentResultOutput',
    Ids: trpcData.Ids,
  },
});

export const useInsertObligationInternalAuditResultTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.internalAuditResult.insertObligation.mutationOptions({
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: trpc.frontend.internalAuditResult.pathKey(),
          }),
          queryClient.invalidateQueries({
            queryKey:
              trpc.frontend.assessment.internalAuditResultCount.queryKey(),
          }),
        ]);
      },
    }),
  });

  return {
    insertObligationInternalAuditResult: async (
      variables: InsertObligationInternalAuditResultInput
    ): Promise<InsertObligationInternalAuditResultMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
